import React, { useEffect, useState } from 'react';
import Signup from './components/signup/signup';
import io from 'socket.io-client';
import './App.css';
import { ToastContainer } from 'react-toastify';
import { showErrorToast, showSuccessToast } from './toast-utils';
import CryptoJS from 'crypto-js';
import JSEncrypt from 'jsencrypt';

const socket = io('https://authenticate-ws.api-uat.adapid.link/');

function App() {
  const [clicked, setClicked] = useState('');
  const [account, setAccount] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [token, setToken] = useState('');
  const [uname, setUname] = useState('');
  const [showButton, setShowButton] = useState(true);
  const [error, setError] = useState('')
  const [reload, setReload] = useState(false)
  const [other, setOther] = useState(false);
  const [userid, setUserId] = useState('');
  const [signup, setSignup] = useState(false);
  const [authenError, setAuthenError] = useState(false);
  const [intruder, setIntruder] = useState(false);
  const [interror, setIntError] = useState(false);
  const [remove, setRemove] = useState(false);
  const [hashValue, setHashValue] = useState('');
  const [publicKey, setPublicKey] = useState('');
  const [user, setUser] = useState('')
  const [userError, setUserError] = useState(false);
  const [tenant, setTenant] = useState({})


  const [apipayload, setApipayload] = useState()
  const [url, setUrl] = useState('')
  const [params, setParams] = useState()

  useEffect(() => {
    const handleIntruderResponse = (response) => {
      if (response) {
        console.log('intruder-response', response);
      }
    }
    socket.on('intruder_response', handleIntruderResponse);

    return () => {
      socket.off('intruder_response', handleIntruderResponse);
    };
  }, [intruder]);

  useEffect(() => {
    const fetchPublicKey = async () => {
      try {
        const response = await fetch('https://uat-js.adapid.link/js/publicKey.pem');
        const publicKey = await response.text();
        setPublicKey(publicKey);
        await fetchData();
      } catch (error) {
        console.error('Error fetching public key:', error);
      }
    };

    fetchPublicKey();

  }, [token]);

  const fetchData = async () => {
    if (performance.navigation.type === performance.navigation.TYPE_RELOAD) {
      console.info("This page is reloaded");
      setReload(true);
    } else {
      console.info("This page is not reloaded");
    }

    const currentUrl = window.location.search;
    const urlParams = new URLSearchParams(currentUrl);
    const extractedToken = decodeURIComponent(urlParams.get('token'));
    console.log(extractedToken)
    setToken(extractedToken)
    const deviceHash = decodeURIComponent(urlParams.get('devicehash'));
    console.log(deviceHash)
    const userloginid = decodeURIComponent(urlParams.get('username'));
    console.log(userloginid)
    setUser(userloginid)
    const parsedDeviceHash = (deviceHash === "null") ? null : deviceHash;
    const decodedEncString = decodeURIComponent(urlParams.get('enc'));
    const encJson = JSON.parse(decodedEncString);
    console.log(encJson)
    setTenant(encJson)

    if (extractedToken) {
      setToken(extractedToken);
    }

    if (token) {
      const hashValue = await webgl();
      setHashValue(hashValue);
      try {
        const deviceDetails = {
          user_agent: navigator.userAgent,
          user_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          language: window.navigator.language,
          user_screen_height: window.screen.height,
          user_screen_width: window.screen.width,
          webgl: hashValue,
          browser_languages: window.navigator.languages[0],
          maxtouch_points: navigator.maxTouchPoints,
          app_name: navigator.appName,
          vendor: navigator.vendor,
          product: navigator.product,
          product_sub: navigator.productSub,
        }

        const requestBody = {
          "device_details": deviceDetails,
          "tenant_id": encJson,
          "device_hash": parsedDeviceHash,
          "user_login_id": userloginid
        };

        const response = await fetch('https://uat-webauthn.adapid.link/api/v1/device/details', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(
            requestBody
          ),
        });
        const data = await response.json();
        console.log(data)
        setUrl(data.url)
        setApipayload(data.payload)
        setParams(data.params)
        console.log(data.payload)

        if (data.message === 'New User') {
          const requestMessage = { "message": "New User", "status_code": "404" }
          const requestHash = await generateSHA256Hash(JSON.stringify(requestMessage));
          if (((data.id).substring(4, (data.id.length) - 4)) === requestHash) {
            setAccount(true);
          } else {
            showErrorToast('Login failed');
          }
        } else if (data.session_id === null) {
          socket.emit('intruder', { 'error': 'Intruder', 'username': userloginid, 'devicedetails': deviceDetails, 'token': extractedToken, 'tenant_id': encJson, 'authentication_type': 'Intruder', 'device_match': false })
          setIntruder(true);
        } else if (data.match === true) {
          const requestMessage = { "session_id": data.session_id, "match": data.match, "user_name": data.user_name, "status_code": "200" };
          const requestHash = await generateSHA256Hash(JSON.stringify(requestMessage));
          if (((data.id).substring(4, (data.id.length) - 4)) === requestHash) {
            setUname(data.user_name);
            handleLogin(data.user_name, deviceDetails, encJson);
            setUserId(data.session_id);
            setIsLoggedIn(true);
          } else {
            showErrorToast('Login failed');
          }
        } else if (data.session_id && data.username) {
          const requestMessage = { "session_id": data.session_id, "username": data.username, "status_code": "200" };
          const requestHash = await generateSHA256Hash(JSON.stringify(requestMessage));
          if (((data.id).substring(4, (data.id.length) - 4)) === requestHash) {
            if (data.username === userloginid) {
              setUname(data.username);
              handleLogin(data.username, deviceDetails, encJson);
              setUserId(data.session_id);
              setIsLoggedIn(true);
            } else {
              setUserError(true)
            }
          } else {
            showErrorToast('Login failed');
          }
        }
      } catch (error) {
        console.error('Error in fetchData:', error);
      }
    }
  };

  const sha256 = (function () {
    var i = 1, j, K = [], H = [];
    while (++i < 18) {
      for (j = i * i; j < 312; j += i) {
        K[j] = 1;
      }
    }

    function x(num, root) {
      return (Math.pow(num, 1 / root) % 1) * 4294967296 | 0;
    }

    for (i = 1, j = 0; i < 313;) {
      if (!K[++i]) {
        H[j] = x(i, 2);
        K[j++] = x(i, 3);
      }
    }

    function S(X, n) {
      return (X >>> n) | (X << (32 - n));
    }

    function SHA256(b) {
      var HASH = H.slice((i = 0)), s = unescape(encodeURI(b)), W = [], l = s.length, m = [], a, y, z;
      for (; i < l;) m[(i >> 2)] |= (s.charCodeAt(i) & 0xff) << (8 * (3 - (i++ % 4)));
      l *= 8;
      m[(l >> 5)] |= 0x80 << (24 - (l % 32));
      m[(z = (l + 64 >> 5) | 15)] = l;

      for (i = 0; i < z; i += 16) {
        a = HASH.slice((j = 0), 8);

        for (; j < 64; a[4] += y) {
          if (j < 16) {
            W[j] = m[j + i];
          } else {
            W[j] = (S((y = W[j - 2]), 17) ^ S(y, 19) ^ (y >>> 10)) + (W[j - 7] | 0) + (S((y = W[j - 15]), 7) ^ S(y, 18) ^ (y >>> 3)) +
              (W[j - 16] | 0);
          }
          a.unshift(
            ((y = (a.pop() + (S((b = a[4]), 6) ^ S(b, 11) ^ S(b, 25)) + (((b & a[5]) ^ (~b & a[6])) + K[j]) | 0) + (W[j++] | 0))) +
            (S((l = a[0]), 2) ^ S(l, 13) ^ S(l, 22)) + ((l & a[1]) ^ (a[1] & a[2]) ^ (a[2] & l))
          );
        }
        for (j = 8; j--;) HASH[j] = a[j] + HASH[j];
      }
      for (s = ''; j < 63;) s += ((HASH[(++j >> 3)] >> (4 * (7 - (j % 8)))) & 15).toString(16);
      return s;
    }
    return SHA256;
  })();

  const webgl = async () => {
    try {
      var canvas, ctx, width = 256, height = 128;
      canvas = document.body.appendChild(document.createElement("canvas"));
      canvas.width = width;
      canvas.height = height;
      ctx =
        canvas.getContext("webgl2") ||
        canvas.getContext("experimental-webgl2") ||
        canvas.getContext("webgl") ||
        canvas.getContext("experimental-webgl") ||
        canvas.getContext("moz-webgl");

      var f =
        "attribute vec2 attrVertex;varying vec2 varyinTexCoordinate;uniform vec2 uniformOffset;void main(){varyinTexCoordinate=attrVertex+uniformOffset;gl_Position=vec4(attrVertex,0,1);}";
      var g = "precision mediump float;varying vec2 varyinTexCoordinate;void main() {gl_FragColor=vec4(varyinTexCoordinate,0,1);}";
      var h = ctx.createBuffer();

      ctx.bindBuffer(ctx.ARRAY_BUFFER, h);

      var i = new Float32Array([
        -0.2, -0.9, 0,
        0.4, -0.26, 0,
        0, 0.7321, 0,
      ]);

      ctx.bufferData(ctx.ARRAY_BUFFER, i, ctx.STATIC_DRAW);
      h.itemSize = 3;
      h.numItems = 3;

      var j = ctx.createProgram();
      var k = ctx.createShader(ctx.VERTEX_SHADER);

      ctx.shaderSource(k, f);
      ctx.compileShader(k);

      var l = ctx.createShader(ctx.FRAGMENT_SHADER);

      ctx.shaderSource(l, g);
      ctx.compileShader(l);
      ctx.attachShader(j, k);
      ctx.attachShader(j, l);
      ctx.linkProgram(j);
      ctx.useProgram(j);

      j.vertexPosAttrib = ctx.getAttribLocation(j, "attrVertex");
      j.offsetUniform = ctx.getUniformLocation(j, "uniformOffset");

      ctx.enableVertexAttribArray(j.vertexPosArray);
      ctx.vertexAttribPointer(j.vertexPosAttrib, h.itemSize, ctx.FLOAT, !1, 0, 0);
      ctx.uniform2f(j.offsetUniform, 1, 1);
      ctx.drawArrays(ctx.TRIANGLE_STRIP, 0, h.numItems);

      var m = "";

      var n = new Uint8Array(width * height * 4);
      ctx.readPixels(0, 0, width, height, ctx.RGBA, ctx.UNSIGNED_BYTE, n);
      m = JSON.stringify(n).replace(/,?"[0-9]+":/g, "");
      setHashValue(sha256(m));
      canvas.style.display = 'none';
      return sha256(m);
    } catch (e) {
      console.error('Error in webgl:', e);
      return null;
    } finally {
      canvas.style.display = 'none';
    }
  };

  useEffect(() => {
    const handleLoginResponse = (response) => {
      if (response.username) {
        console.log(response.username);
        //socket.disconnect();
      } else if (response.error == 'Intruder' && intruder == false) {
        setIntError(true);
        console.log(response)
        socket.disconnect();
      } else {
        setOther(true);
        console.log(response);
        socket.disconnect();
      }
    };

    socket.on('login_response', handleLoginResponse);

    // fetchData();
    return () => {
      socket.off('login_response', handleLoginResponse);
    };

  }, [token]);

  function generateRandom() {
    return 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, function () {
      return (Math.random() * 16 | 0).toString(16);
    });
  }


  async function getEncryptedData(data) {

    var key = generateRandom(), iv = generateRandom();

    var keyEnc = CryptoJS.enc.Utf8.parse(key),
      keyEnciv = CryptoJS.enc.Utf8.parse(iv);
    var encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), keyEnc, { iv: keyEnciv, mode: CryptoJS.mode.CBC });

    let jsEncrypter = new JSEncrypt();
    jsEncrypter.setPublicKey(publicKey);

    return {
      key: jsEncrypter.encrypt(key),
      iv: jsEncrypter.encrypt(iv),
      data: encrypted.toString()
    };
  }

  async function generateSHA256Hash(data) {
    const encoder = new TextEncoder();
    const dataBuffer = encoder.encode(data);
    const hashBuffer = await window.crypto.subtle.digest('SHA-256', dataBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');
    return hashHex;
  }

  const handleLogin = async (username, deviceDetails, tenantid) => {
    if (!reload) {
      setClicked(true);
      const currentUrl = window.location.search;
      const urlParams = new URLSearchParams(currentUrl);
      const token = urlParams.get('token');
      const authenObj = {
        tenant_id: tenantid,
        token: token,
        username: username,
        user_verification: 'preferred',
        rp_id: 'authenticate-uat.adapid.link'
      }
      const authenEnc = await getEncryptedData(authenObj);
      try {
        const response = await fetch('https://uat-webauthn.adapid.link/api/v1/authenticate/generate/',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              ...authenEnc
            }),
          });

        if (response.ok) {
          const result = await response.json();
          const authenMessage = {
            "challenge": result.challenge,
            "timeout": 6000,
            "rpId": "authenticate-uat.adapid.link",
            "allowCredentials": [
              {
                "id": result.allowCredentials[0].id,
                "type": "public-key",
                "transports": [
                  "internal"
                ],
              }
            ],
            "userVerification": "preferred"
          }
          const authenHash = await generateSHA256Hash(JSON.stringify(authenMessage));

          if (((result.id).substring(4, (result.id.length) - 4)) === authenHash) {

            const base64CredentialId = result.allowCredentials[0].id;

            function base64urlDecode(base64url) {
              const base64 = base64url.replace(/-/g, '+').replace(/_/g, '/');
              const paddedBase64 = base64.padEnd((base64.length + 3) & ~3, '=');
              return atob(paddedBase64);
            }

            const binaryCredentialId = base64urlDecode(base64CredentialId);

            const credentialIdArray = new Uint8Array(binaryCredentialId.length);
            for (let i = 0; i < binaryCredentialId.length; i++) {
              credentialIdArray[i] = binaryCredentialId.charCodeAt(i);
            }

            const credentialId = credentialIdArray.buffer;

            const publicKeyCredentialRequestOptions = {
              challenge: Uint8Array.from(result.challenge, c => c.charCodeAt(0)),
              allowCredentials: [{
                id: credentialId,
                type: 'public-key',
                transports: ['internal'],
              }],
              timeout: 60000,
            };

            const assertion = await navigator.credentials.get({
              publicKey: publicKeyCredentialRequestOptions
            });

            const clientDataAuthen = btoa(String.fromCharCode.apply(null, new Uint8Array(assertion.response.clientDataJSON)));
            const authenticatorDataAuthen = btoa(String.fromCharCode.apply(null, new Uint8Array(assertion.response.authenticatorData)));
            const signature = btoa(String.fromCharCode.apply(null, new Uint8Array(assertion.response.signature)));
            const userHandle = btoa(String.fromCharCode.apply(null, new Uint8Array(assertion.response.userHandle)));

            const authenVerify = {
              tenant_id: tenantid,
              token: token,
              rp_id: 'authenticate-uat.adapid.link',
              "username": username,
              "response": {
                "id": base64CredentialId,
                "rawId": base64CredentialId,
                "response": {
                  "authenticatorData": authenticatorDataAuthen,
                  "clientDataJSON": clientDataAuthen,
                  "signature": signature,
                  "userHandle": userHandle
                },
                "type": "public-key",
                "clientExtensionResults": {
                },
                "authenticatorAttachment": "platform"
              }
            }

            const authenVerifyEnc = await getEncryptedData(authenVerify)
            const responseAuthen = await fetch('https://uat-webauthn.adapid.link/api/v1/authenticate/verify/',
              {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  ...authenVerifyEnc
                }),
              });

            const authenResponse = await responseAuthen.json();

            const authenVerifymessage = { "credentialId": authenResponse.credentialId, "newSignCount": authenResponse.newSignCount, "credentialDeviceType": authenResponse.credentialDeviceType, "credentialBackedUp": authenResponse.credentialBackedUp }
            const authenVerifyhash = await generateSHA256Hash(JSON.stringify(authenVerifymessage));

            if (authenResponse.credentialId) {
              if (((authenResponse.id).substring(4, (authenResponse.id.length) - 4)) === authenVerifyhash) {
                socket.emit('signup', {
                  'token': token, 'username': username, 'tenant_id': tenantid, 'devicedetails': deviceDetails, 'authentication_type': 'Legitimate User', 'device_match': true
                });
                setShowButton(false);
                setError(false)
              } else {
                showErrorToast('Login failed');
              }
            } else {
              console.log('Authentication failed');
              setError(true)
            }
          } else {
            showErrorToast('Login failed');
          }
        } else {
          setAuthenError(true);
        }
      } catch (error) {
        console.error('WebAuthn error:', error);
        setError(true);
      }
    }
  }

  const handleOtherUser = async () => {
    const userId = userid;
    const tenant_id = tenant;
    console.log(tenant_id)
    const apiUrl = `https://uat-webauthn.adapid.link/api/v1/qr/user/delete/`;

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          'user_id': userId,
          'tenant_id': tenant
        })
      });

      const data = await response.json();
      const deleteMsg = { "message": "User deleted from DB Successfully", "status_code": "200" }
      const deleteHash = await generateSHA256Hash(JSON.stringify(deleteMsg));
      if (data.message == "User deleted from DB Successfully") {
        if (((data.id).substring(4, (data.id.length) - 4)) === deleteHash) {
          showSuccessToast('Device removed successfully');
          setRemove(true);
        } else {
          showErrorToast('Login failed');
        }
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="App">
        <button disabled style={{ width: '100%', border: 'none', background: '#25c77b', color: 'white' }}>Secured connection established by adapID</button>
        <div>
          <img src={require('../src/assets/adapId.png')} height="80px" width="85px" alt="Login" />
        </div>
        {interror ? (<div className="centered-message" style={{ color: 'red', fontWeight: 'bold', fontSize: '24px' }}>Page refreshed, Please try again</div>) : intruder ? (<div className='centered-message' style={{ color: 'red', fontWeight: 'bold', fontSize: '24px' }}>Fraudulent user - Intruder</div>) : account || signup ? (
          <Signup token={token} socket={socket} hashValue={hashValue} publicKey={publicKey} userid={userid} user={user} tenant={tenant} url={url} payload={apipayload} params={params} />
        ) : isLoggedIn ? (
          reload ? (
            <div className="centered-message">
              <div style={{ fontWeight: 'bold', fontSize: '24px' }}>Please scan again to login</div>
            </div>
          ) : (
            <div className="centered-message">
              {showButton && (
                <div>
                  {error && <div style={{ marginTop: '5px', fontSize: '24px', color: 'red' }}>Authentication failed</div>}
                  {authenError && <div style={{ marginTop: '5px', color: 'red' }}>Login failed <br />Scan again to login</div>}
                </div>
              )}
              {!showButton && clicked && (
                <div>
                  {other ? (
                    <div style={{ color: 'red', fontSize: '24px', fontWeight: 'bold' }}>Error occurred, try again</div>
                  ) : (
                    <div>
                      {remove ? (
                        <div className='centered-message' style={{ fontSize: '24px', color: '#00b0e5' }}>
                          To register the device, Please scan again
                        </div>
                      ) : (
                        <div>
                          <div style={{ color: 'green', fontSize: '24px', fontWeight: 'bold' }}>User logged in</div>
                          <button style={{ padding: '10px', background: '#66b6ec', color: 'white', border: 'none', marginTop: '10px' }} onClick={handleOtherUser}>
                            Remove my profile
                          </button>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>)
        ) : <div>{userError && <div className='centered-message' style={{ fontSize: '24px', color: 'red' }}>Device already registered</div>} </div>}
        <div>Secured by <span style={{ fontWeight: 'bold', fontSize: '24px' }}>adapID</span></div>
      </div>
    </>
  );
}

export default App;